<template>
  <div class="wrapper">
    <div class="title" style="margin-top: 10px;">
      账号余额：<span class="c"> {{user.money}}  闪音币</span>
    </div>
    <div class="price">
      <div class="title">充值闪音币</div>
      <div class="priceBox">
        <div class="priceList" 
        :class="{'active': index == showIndex}" 
        v-for="(item,index) in priceList"
        :key="index"
        @click="tabChange(index)">
          <div class="shangpin">
            <img src="../../assets/img/sy/payh5/xyb.png">
            <div>{{item.coin}}</div>
          </div>
          <div class="jiage">￥{{item.price}}</div>
          <img class="icon" src="../../assets/img/sy/payh5/gou.png">
        </div>
      </div>
    </div>
    <div class="lineb"></div>
    <div class="payfun">
      <div class="title">支付方式</div>
      <div class="payfunBox">
        <div class="payOne" 
        :class="{'line': index == 0}" 
        v-for="(item,index) in payFunList" 
        :key="index"
        @click="changRadio(index)">
          <div class="payName">
            <img class="payIcon" :src="item.icon">
            <span>{{item.name}}</span>
          </div>
          <div class="radio" :class="{'active': index == payFunIndex}">
          </div>
        </div>
      </div>
    </div>
    <div class="btn" @click="toPay">
      <div class="goPay">立即充值</div>
    </div>
    <div class="other">
      <div class="xieyi">
      点击充值，表示同意<span>《充值协议》</span>
      </div>
      <div class="help" v-show="false">
        <img src="../../assets/img/sy/payh5/wenti.png">
        <span>充值帮助</span>
      </div>
    </div>
  </div>
</template>
<script>

import axios from 'axios'
import dsBridge from '../../component/dsbridge'

export default {
  name: 'sy_payH5',
  data () {
    return {
      API_DOMAIN: window.location.host.match(/mp\.le/) ? 'https://test-api-svoice.le.com' : 'https://api-svoice.le.com',
      // token: '18bd9bd86b4920875fad92faf0494fcc0c632e4bc4ca7ba6398b0d5fefb6be4b239e64a66c26fd5df4092463626bb4250e28f871b905c482c7abc06e377eac452d7d34479268516b3eb29de00ba500ec',
      // pcode: '230110000',
      token: '',
      pcode: '',
      version: '',
      user:{
        name: '请登录',
        money: 0
      },
      showIndex: 0,
      priceList:[],
      payFunList: [
        {
          name: '微信支付',
          icon: 'http://i0.letvimg.com/lc06_lemf/201912/04/21/08/wx.png'
        },
        {
          name: '支付宝支付',
          icon: 'http://i2.letvimg.com/lc05_lemf/201912/05/15/54/zfb.png'
        }
      ],
      payFunIndex: 0,
      payMode: ['2','1'],
      roomId: 0
    }
  },
  components: {},
  computed: {},
  async mounted (){
    this.bridgeRegister();//监听回调
    await this.getUser();// 获取用户信息
    await this.getRoomId();//获取房间ID
  },
  methods: {
    async getRoomId (){
      dsBridge.call('getCurrentRoomAsync', async ret => {
        var id = JSON.parse(ret).id
        if(!id){
          id = JSON.parse(ret)['id:']
        }
        if(id){
          this.roomid = id
        }
      })
    },
    async getUser() {
      dsBridge.call('getTokenAsync', ret => {
        try {
          const userInfo = JSON.parse(ret)
          this.token = userInfo.token
          if (!this.token || this.token === '') {
            this.user.name = '请登录'
            this.user.money = '0'
            this.$toast.fail("请登录")
            return
          }
          dsBridge.call('getAppInfoAsync', async ret => {
            const appInfo = JSON.parse(ret);
            this.pcode = appInfo.pcode;
            this.version = appInfo.version;
            await this.getMoney();
            await this.getPriceList();
          })
        } catch (e) {
          this.$notify('未知错误！，请刷新页面')
        }
      });
    },
    async getMoney (){
      let walletRet,
          walletUrl = `${this.API_DOMAIN}/sales/wallet?accesstoken=${this.token}&pcode=${this.pcode}&version=${this.version}`;
      try {
        walletRet = await axios.get(walletUrl, { timeout: 3000 });
      } catch (error) {
        try {
          walletRet = await axios.get(walletUrl, { timeout: 3000 });
        } catch (error) {
          this.$notify('获取钱包信息失败！，请刷新页面')
          return
        }
      }
      let walletData = walletRet.data.data || '';
      if (!walletData){
        this.$notify('获取用户信息失败！，请刷新页面')
        return
      }
      this.user.money = walletData.coin_amount || 0;
    },
    async getPriceList() {
      let ret,
          url = `${this.API_DOMAIN}/sales/recharge/list/lebz?accesstoken=${this.token}&pcode=${this.pcode}&version=${this.version}`;
      try {
        ret = await axios.get(url, { timeout: 3000 });
      } catch (error) {
        try {
          ret = await axios.get(url, { timeout: 3000 });
        } catch (error) {
          this.$notify(ret && ret.data && ret.data.message || '网络错误，请稍候再试')
          return
        }
      }
      let json = ret.data.data&&ret.data.data.list || {};
      if (!json){ 
        this.$notify('网络错误，请稍候再试')
        return
      }
      this.priceList = json;
    },
    async toPay (){
      let pay_mode = this.payMode[this.payFunIndex],
          third_pay_mode = 0,
          recharge_package_id = this.priceList[this.showIndex].id;
      let ret,
          url = `${this.API_DOMAIN}/sales/recharge/order?accesstoken=${this.token}&pay_mode=${pay_mode}&third_pay_mode=${third_pay_mode}&recharge_package_id=${recharge_package_id}&room_id=${this.roomid || 0}&pcode=${this.pcode}&version=${this.version}`;
      try {
        ret = await axios.get(url, { timeout: 3000 });
      } catch (error) {
        try {
          ret = await axios.get(url, { timeout: 3000 });
        } catch (error) {
          this.$notify(ret && ret.data && ret.data.message || '网络错误，请稍候再试')
          return
        }
      }
      let json = ret.data.data&&ret.data.data || {};
      if (!json){ 
        this.$notify('网络错误，请稍候再试')
        return
      }
      let webUrl = this.payMode[this.payFunIndex] == 2 ? json.mweb_url : json;
      window.location.href = webUrl;
    },
    bridgeRegister(){
      // 充值完回调
      dsBridge.register('rechargeCallback', () => {
        this.getMoney();
      });
    },
    tabChange (index){
      this.showIndex = index;
    },
    changRadio (index){
      this.payFunIndex = index;
    }
  }
}
</script>
<style>
  body,
  html {
    height: 100%;
  }

  #app {
    height: 100%;
    background: #fff;
  }
  .wrapper {
  }
  .wrapper .title {
    padding-left: 15px;
    height: 52px;
    line-height: 52px;
    font-size: 14px;
  }
  .wrapper .title .c{
    color: #7B40FF;
  }
  .wrapper .priceBox{
    display:flex;
    flex-direction:row;
    flex-wrap: wrap;
    margin-left: 20px;
  }
  .wrapper .priceList{
    position: relative;
    display:flex;
    flex-direction:column;
    justify-content : center;
    align-items: center;
    width: 97px;
    height: 45px;
    border: 1px solid #BAC0C5;
    border-radius: 4px;
    border-radius: 4px;
    margin-bottom: 20px;
    margin-right: 19px;
  }
  .wrapper .priceList.active{
    border: 1px solid #7B40FF;
  }
  .shangpin{
    display:flex;
    flex-direction:row;
    justify-content : center;
    font-size: 14px;
    color: #7B40FF;
    text-align: center;
    align-items: center
  }
  .shangpin img{
    width: 14px;
    height: 14px;
  }
  .lineb {
    height: 10px;
    background: #F3F3F3;
  }
  .jiage {
    font-size: 12px;
    text-align: center;
  }
  .priceList .icon{
    display: none;
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: 1px;
    right: 1px;
  }
  .wrapper .priceList.active .icon{
    display: block;
  }
  .wrapper .payfun {
  }
  
  .wrapper .payfun .payOne {
    display:flex;
    flex-direction:row;
    justify-content : space-between;
    align-items: center;
    margin-left: 15px;
    margin-right: 15px;
    height: 56px;
    line-height: 56px;
  }
  .payfun .payOne .payName {
    display:flex;
    align-items: center;
  }
  .payfun .payIcon{
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
  .payfun .line{
    border-bottom: 1px solid #EEEEEE;
  }
  .payfun .radio {
    display:flex;
    align-items: center;
    background: url('../../assets/img/sy/payh5/no.png') no-repeat;
    background-size: 100%;
    width: 14px;
    height: 14px;
  }
  .payfun .radio.active{
    background: url('../../assets/img/sy/payh5/yes.png') no-repeat;
    background-size: 100%;
  }
  .btn {
    display:flex;
    justify-content : center;
  }
  .goPay {
    margin-top: 6px;
    margin-bottom: 10px;
    text-align: center;
    background: #7B40FF;
    border-radius: 28.5px;
    border-radius: 28.5px;
    height: 38px;
    width: 335px;
    line-height: 38px;
    color: #fff;
    font-size: 14px;
  }
  .other {
    display:flex;
    flex-direction:column;
    justify-content : center;
    align-items: center;
    font-family: PingFang-SC-Medium;
    font-size: 12px;
    color: #888888;
    letter-spacing: -0.24px;
    text-align: center;
  }
  .other .xieyi{
    transform:scale(0.9);
  }
  .other .xieyi span{
    color: #000;
  }
  .help {
    display:flex;
    justify-content : center;
    align-items: center;
    color: #444444;
    margin-top: 26px;
  }
  .help span{
    transform:scale(0.9);
  }
  .help img{
    width: 12px;
    height: 12px;
  }
</style>